import intl from 'react-intl-universal';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Toast } from '@/components/Message';
import store from '../store';
import { checkDomain } from '@/utils/utils';

const { REACT_APP_APIURL, REACT_APP_APIURL_BACKUP, REACT_APP_IMURL } = process.env;
const APP_APIURL = async () => await checkDomain(REACT_APP_APIURL) ? REACT_APP_APIURL : REACT_APP_APIURL_BACKUP

const axiosX = axios.create({
  timeout: 80000,
});

const sendClient = (agreement: string, jsonStr: string) => {
  if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
    if (window.android) {
      window.android[agreement](jsonStr);
    }
  } else if (window.Sac_jsCallC) {
    window.Sac_jsCallC(agreement, jsonStr);
  } else {
    const obj: any = {};
    obj[agreement] = jsonStr;
    window.webkit?.messageHandlers?.Sac_jsCallC.postMessage(obj);
  }
};
interface IResData<T> {
  code: number;
  msg: string;
  data: T;
}

axiosX.interceptors.request.use(async (config) => {
  const newConfig = { ...config };
  newConfig.baseURL = config.baseURL ||  await APP_APIURL();
  newConfig.headers.token = store.getState().common.token || '';
  // axios会根据传入的data不同类型自动对应设置headers的Content-Type成以下形式
  // 'application/json; charset=UTF-8' 'application/x-www-form-urlencoded' 'multipart/form-data'
  return newConfig;
});

axiosX.interceptors.response.use((response: AxiosResponse<IResData<any>>) => {
  if ([200, 304].includes(response.status)) {
    const res = response.data;
    if (REACT_APP_IMURL === response.config.baseURL) {
      return Promise.resolve(res);
    }
    if (res.code === 20012) {
      const tokenInfoStr = JSON.stringify({
        errID: res.code,
        errMsg: res.msg,
      });
      sendClient('onWebError', tokenInfoStr);
      return Promise.reject(res);
    }
    // 上传截图的put方法状态码为200但不返回响应，特殊处理
    if (response.config.method === 'put') {
      return;
    }
    const url = response.config.url as string;
    if (url.includes('/api/schedule/get-classroom') || url.includes('/api/login/fetchToken/')) {
      // 这两个接口code值为0，和其他code值为200的不一样，特殊处理一下
      if (res.code === 0) {
        return res.data;
      }
      return Promise.reject(res);
    }
    if (url.includes('api/inode/bulk')) {
      // 云盘接口返回特殊 异常情况返回空数组
      if(Array.isArray(res) && res.length > 0) {
        return res
      }
      return Promise.reject(res);
    }
    if (url.includes('/bc/events')) {
      // 云盘查询互动题接口
      if (res) {
        return res
      }
      return Promise.reject(res);
    }
    if (res.code === 200) {
      return res.data;
    }
    if (res.msg) {
      Toast.error(res.msg);
    }
    return Promise.reject(res);
  }

  Toast.error(response.status);
  return Promise.reject(response);
}, (err) => {
  console.log('接口请求错误：', err.response);
  if (err?.response) {
    Toast.error(err.response.status);
  } else {
    Toast.error(intl.get('NETWORK_ERROR'));
  }
  return Promise.reject(err);
});

/**
 * get请求
 * @method get
 * @param {url, params} 请求地址，请求参数
 */
const get = <T = any>(
  url: string | string[],
  params?: any,
  config?: AxiosRequestConfig | undefined,
): Promise<T> => axiosX.get(`${url}`, { params, ...config });

/**
 * post请求
 * @method post
 * @param {url, data} 请求地址，请求参数
 */
const post = <T = any>(
  url: string,
  data: any,
  config?: AxiosRequestConfig | undefined,
): Promise<T> => axiosX.post(`${url}`, data, config);

const put = <T = any>(
  url: string,
  data: any,
  config?: AxiosRequestConfig | undefined,
): Promise<T> => axiosX.put(`${url}`, data, config);

/**
 * 用navigator.sendBeacon在页面销毁前同步上报数据
 * @param url 接口url
 * @param data 参数
 * @returns
 */
const sendBeacon = async(url: string, data: any) => {
  const apiUrl = await APP_APIURL();
  navigator.sendBeacon(`${apiUrl}${url}`, data);
} 
const Common = { get, post, put, sendBeacon };
export default Common;
